/*
*   @site           Preloaded: Site
*   @function       Init
*   @author         Last17
*   @copyright      Copyright 2025, Prelaoded.com
*   @version        0.01
*
*********************************************************************************************/

//--------------------------------------------------------------------------
//  Import
//--------------------------------------------------------------------------

//Sass
import '../scss/app.scss';

//App
import Application from './Application';


//--------------------------------------------------------------------------
//  Init app on load (should we make this document?)
//--------------------------------------------------------------------------
window.onload = () => {
  window.app = new Application();
};